import { formatearFechaHora, formatearRevision } from "@gestiondoc/shared";
import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "../api.ts";
import { Encabezado } from "../componentes/Encabezado.tsx";
import { BotonEnlace, EstadoVacio } from "../componentes/ui.tsx";

/** Bandeja "Por leer": las revisiones vigentes de las que todavía no di acuse. */
export function PaginaLecturas() {
  const trpc = useTRPC();
  const pendientes = useQuery(trpc.acuses.pendientes.queryOptions());

  return (
    <div>
      <Encabezado overline="Sistema" titulo="Por leer" />
      {pendientes.isPending && <EstadoVacio>Cargando…</EstadoVacio>}
      {pendientes.data && pendientes.data.length === 0 && (
        <EstadoVacio>Estás al día: no tienes documentos por leer.</EstadoVacio>
      )}
      {pendientes.data && pendientes.data.length > 0 && (
        <ul className="divide-y divide-borde/60 rounded-tarjeta border border-borde bg-white">
          {pendientes.data.map((p) => (
            <li key={p.codigo} className="flex flex-wrap items-center gap-3 px-4 py-3">
              <div className="min-w-0 flex-1">
                <div className="font-mono text-[12px] text-marino">
                  {p.codigo} · Rev. {formatearRevision(p.revision)}
                </div>
                <div className="font-semibold">{p.nombre}</div>
                <div className="text-[11.5px] text-texto-3">
                  {p.proceso.nombre}
                  {p.aprobadaEn && ` · vigente desde el ${formatearFechaHora(p.aprobadaEn)}`}
                </div>
              </div>
              <BotonEnlace to="/acuse/$codigo" params={{ codigo: p.codigo }} variante="primario">
                Leer y dar acuse
              </BotonEnlace>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
